import React from "react";
import QRGenerator from "qrcode.react";

type Props = {
  content: string;
  docId: string;
  hidden: boolean;
  size?: number;
};

const QRCode: React.FC<Props> = ({content, docId, hidden, size}) => {
  const styles = hidden ? {visibility: "hidden", height: 0, width: 0, overflow: 'hidden'} : ({} as any);
  return (
    <div style={styles} data-testid="qr-code">
      <QRGenerator value={content} size={size || 850} id={docId}/>
    </div>
  );
};

export default QRCode;
